module.exports = __webpack_public_path__ + "assets/img/3.aa70f508.png";